import React from "react";

function SentimentDot({ sentiment }) {
  const c =
    sentiment === "positive"
      ? "#c1d850"
      : sentiment === "negative"
      ? "#ff4b4f"
      : "#f59e0b";
  return (
    <span
      style={{
        display: "inline-block",
        width: 8,
        height: 8,
        borderRadius: "50%",
        background: c,
        marginRight: 6,
      }}
    />
  );
}

export default SentimentDot;
